import React from 'react';
import PropTypes from 'prop-types';
import Asset from '../../../../../requests/apa/Asset';
import './_MundialButton.scss';

/**
 * MundialButton
 * 
 * Componente de botón circular con ícono de navegación
 * Dimensiones: 58x58 px (3.867rem)
 * Diseñado según el archivo Figma PDX_Large-Focus_Mundial-2026_Fase2
 */

const MundialButton = ({ onClick, className = '', id = '', dataOptions = {} }) => {
  return (
    <a
      className={`mundial-button ${className}`}
      href="#"
      onClick={(e) => { e.preventDefault(); onClick(e); }}
      id={id}
      aria-label="Mundial 2026"
      title="Volver"
      {...dataOptions}
    >
      <img
        className="mundial-button__icon"
        src={Asset.get('eventodeportivo_icono_chevronizquierdo_default', '')}
        alt="volver"
      />
    </a>
  );
};

MundialButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string,
  dataOptions: PropTypes.object
};

MundialButton.defaultProps = {
  onClick: () => {},
  className: '',
  id: '',
  dataOptions: {}
};

export default MundialButton;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MundialButton/MundialButton.jsx